import { render, staticRenderFns } from "./patentlist.vue?vue&type=template&id=d52d7946"
import script from "./patentlist.vue?vue&type=script&lang=js"
export * from "./patentlist.vue?vue&type=script&lang=js"
import style0 from "./patentlist.vue?vue&type=style&index=0&id=d52d7946&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports